export default "__VITE_ASSET__CojtlmuT__"